"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = supportsProtoAssignment;
var x = {};
var y = { supports: true };
try {
  x.__proto__ = y;
} catch (err) {}

function supportsProtoAssignment() {
  return x.supports || false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-proxy/modules/supportsProtoAssignment.js
 ** module id = 241
 ** module chunks = 0
 **/